// reCAPTCHA v3 site key (public, safe to include in client code)
// To disable reCAPTCHA in dev, set to empty string - but note: auth
// (login/register) now REQUIRES a token on the backend, other endpoints
// still skip verification when no token is sent
// Sandbox key
export const RECAPTCHA_SITE_KEY = '6Lf4j34sAAAAAKbBi2t0_b38L6BgLqhPuz6LzbfK';
// Production key
// export const RECAPTCHA_SITE_KEY = '6Ld4kH4sAAAAAH7ZtamRHsVcyj05Nevvwk8DRFGX';
